import React from 'react';
import useTheme from 'branding/theme';
import useComponentMargin from '../../hooks/useComponentMargin';
import useLocalization from 'localization';
/** used with checkboxes and radios */
const ChoiceLabel = ({ htmlFor, disabled = false, children, styles }) => {
    const { t } = useLocalization();
    const { colors, typography, sizing } = useTheme();
    const marginStyles = useComponentMargin({ marginHorizontal: 'small' });
    const mergedStyles = {
        ...typography.paragraph.regular,
        ...marginStyles,
        ...(disabled && { color: colors.neutrals.textGamma }),
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: 0,
        minWidth: '96%',
        paddingTop: sizing.component.padding.small,
        paddingBottom: sizing.component.padding.small,
        ...styles
    };
    return (React.createElement("label", { htmlFor: htmlFor, style: mergedStyles }, typeof children === 'string' ? t(children) : children));
};
export default ChoiceLabel;
//# sourceMappingURL=index.js.map